import { createRouter, createWebHashHistory } from 'vue-router'
import estimateRouter from './estimate.js'

const publicRoutes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/noPermission',
    name: 'noPermission',
    component: () => import('../views/error/noPermission.vue'),
    meta: {
      title: '账号无权限',
    },
  },
  {
    path: '/noDish',
    name: 'noDish',
    component: () => import('../views/error/noDish.vue'),
    meta: {
      title: '无菜品',
    },
  },
  {
    path: '/noOperation',
    name: 'noOperation',
    component: () => import('../views/error/noOperation.vue'),
    meta: {
      title: '个人工作台',
    },
  },
]
const waimaiRouter = [
  {
    path: '/waimai/logList',
    name: 'waimaiLogList',
    component: () => import('../views/waimai/log/logList.vue'),
    meta: {
      title: '操作记录',
    },
  },
  {
    path: '/waimai/listMenu',
    name: 'waimaiListMenu',
    component: () => import('../views/waimai/menu/listMenu.vue'),
    meta: {
      title: '外卖餐单管理',
    },
  },
  {
    path: '/waimai/setMenu',
    name: 'waimaisetMenu',
    component: () => import('../views/waimai/menu/setMenu.vue'),
    meta: {
      title: '设置餐单',
    },
  },
  {
    path: '/waimai/sellOutMenu',
    name: 'waimaisellOutMenu',
    component: () => import('../views/waimai/menu/sellOutMenu.vue'),
    meta: {
      title: '菜品沽清/解沽设置',
    },
  },
  {
    path: '/waimai/setNewOutMenu',
    name: 'waimaiSetNewOutMenu',
    component: () => import('../views/waimai/menu/setNewOutMenu.vue'),
    meta: {
      title: '菜品沽清/解沽设置',
    },
  },
]

const kvsRouter = [
  {
    path: '/kvs/index',
    name: 'kvsIndex',
    component: () => import('../views/kvs/index'),
    meta: {
      title: '外卖系统设置',
    },
  },
  {
    path: '/kvs/indexSwitch',
    name: 'kvsIndexSwitch',
    component: () => import('../views/kvs/indexSwitch'),
    meta: {
      title: '外卖系统设置',
    },
  },
  {
    path: '/kvs/prefabricate',
    name: 'kvsPrefabricate',
    component: () => import('../views/kvs/prefabricate'),
    meta: {
      title: '菜品预制模式',
    },
  },
  {
    path: '/kvs/prefabricateHours',
    name: 'kvsPrefabricateHours',
    component: () => import('../views/kvs/prefabricateHours'),
    meta: {
      title: '预制时段配置',
    },
  },
  {
    path: '/kvs/prefabricateHours/add',
    name: 'kvsPrefabricateHoursAdd',
    component: () => import('../views/kvs/prefabricateHours/add.vue'),
    meta: {
      title: '添加预制时段',
    },
  },
  {
    path: '/kvs/orderMode/index',
    name: 'kvsOrderModeIndex',
    component: () => import('../views/kvs/orderMode/index.vue'),
    meta: {
      title: '设置分单模式',
    },
  },
  {
    path: '/kvs/orderMode/addStation',
    name: 'kvsOrderModeAddStation',
    component: () => import('../views/kvs/orderMode/addStation.vue'),
    meta: {
      title: '添加分拣工位',
    },
  },
  {
    path: '/kvs/orderMode/stationList',
    name: 'kvsOrderModeStationList',
    component: () => import('../views/kvs/orderMode/stationList.vue'),
    meta: {
      title: '添加分拣工位',
    },
  },
  {
    path: '/kvs/orderCountdown/index',
    name: 'kvsOrderCountdown',
    component: () => import('../views/kvs/orderCountdown/index.vue'),
    meta: {
      title: '订单分拣时间设置',
    },
  },
  {
    path: '/kvs/switchConf/Detail',
    name: 'kvsSwitchConfDetail',
    component: () => import('../views/kvs/switchConf/detail'),
    meta: {
      title: '外卖系统设置',
    },
  },
]
const kdsRouter = [
  {
    path: '/kds/index',
    name: 'kdsIndex',
    component: () => import('../views/kvs/kds/index.vue'),
    meta: {
      title: '生产系统设置',
    },
  },
  {
    path: '/kds/mergeDish',
    name: 'kdsMergeDish',
    component: () => import('../views/kvs/kds/mergeDish.vue'),
    meta: {
      title: '菜品合并设置',
    },
  },
  {
    path: '/kds/dishAlias',
    name: 'kdsDishAlias',
    component: () => import('../views/kvs/kds/dishAlias.vue'),
    meta: {
      title: '菜品别名管理',
    },
  },
  {
    path: '/kds/durationSetting/setting',
    name: 'kdsDurationSetting',
    component: () => import('../views/kvs/kds/durationSetting/setting.vue'),
    meta: {
      title: '设置出餐时长',
    },
  },
  {
    path: '/kds/durationSetting/dishList',
    name: 'kdsDurationDishList',
    component: () => import('../views/kvs/kds/durationSetting/dishList.vue'),
    meta: {
      title: '选择菜品',
    },
  },
  {
    path: '/kds/durationSetting/setSubmission',
    name: 'kdsDurationSetSubmission',
    component: () => import('../views/kvs/kds/durationSetting/setSubmission.vue'),
    meta: {
      title: '设置菜品出餐时长',
    },
  },
  {
    path: '/kds/durationSetting/batchSelectDish',
    name: 'kdsDurationBatchSelectDish',
    component: () => import('../views/kvs/kds/durationSetting/batchSelectDish.vue'),
    meta: {
      title: '选择菜品',
    },
  },
]

const targetRouter = [
  {
    path: '/targetManage/index',
    name: 'targetIndex',
    component: () => import('../views/targetManage/index'),
    meta: {
      title: '目标看板',
    },
  },
  {
    path: '/targetManage/target/index',
    name: 'targetManageIndex',
    component: () => import('../views/targetManage/target/index'),
    meta: {
      title: '我的目标',
    },
  },
  {
    path: '/targetManage/target/addTarget',
    name: 'addTargetIndex',
    component: () => import('../views/targetManage/target/addTarget'),
    meta: {
      title: '新增目标',
    },
  },
  {
    path: '/targetManage/target/issueTarget',
    name: 'issueTargetIndex',
    component: () => import('../views/targetManage/target/issueTarget'),
    meta: {
      title: '下发目标',
    },
  },
  {
    path: '/targetManage/target/targetSplitOrganize',
    name: 'targetSplitOrganizeIndex',
    component: () => import('../views/targetManage/target/targetSplitOrganize'),
    meta: {
      title: '选择目标拆解组织',
    },
  },
  {
    path: '/targetManage/target/analyseTarget',
    name: 'analyseTargetIndex',
    component: () => import('../views/targetManage/target/analyseTarget'),
    meta: {
      title: '拆解目标',
    },
  },
  {
    path: '/targetManage/target/analyseTargetStore',
    name: 'analyseTargetStoreIndex',
    component: () => import('../views/targetManage/target/analyseTargetStore'),
    meta: {
      title: '拆解目标',
    },
  },
  {
    path: '/targetManage/target/issueTargetRecipient',
    name: 'issueTargetRecipientIndex',
    component: () => import('../views/targetManage/target/issueTargetRecipient'),
    meta: {
      title: '下发目标',
    },
  },
  {
    path: '/targetManage/target/targetCheck',
    name: 'targetCheckIndex',
    component: () => import('../views/targetManage/target/targetCheck'),
    meta: {
      title: '目标复核',
    },
  },
  {
    path: '/targetManage/target/targetDetail',
    name: 'targetDetailIndex',
    component: () => import('../views/targetManage/target/targetDetail'),
    meta: {
      title: '目标详情',
    },
  },
  {
    path: '/targetManage/target/targetDetailStore',
    name: 'targetDetailStoreIndex',
    component: () => import('../views/targetManage/target/targetDetailStore'),
    meta: {
      title: '目标详情',
    },
  },
  {
    path: '/targetManage/targetSet/index',
    name: 'targetSetIndex',
    component: () => import('../views/targetManage/targetSet/index'),
    meta: {
      title: '目标设置',
    },
  },
  {
    path: '/targetManage/targetSet/targetHandover',
    name: 'targetHandoverIndex',
    component: () => import('../views/targetManage/targetSet/targetHandover'),
    meta: {
      title: '目标交接',
    },
  },
  {
    path: '/targetManage/targetSet/coreDishes',
    name: 'coreDishesIndex',
    component: () => import('../views/targetManage/targetSet/coreDishes'),
    meta: {
      title: '核心菜品方案设置',
    },
  },
  {
    path: '/targetManage/dataBoard/targetDataBoard',
    name: 'targetDataBoardIndex',
    component: () => import('../views/targetManage/dataBoard/targetDataBoard'),
    meta: {
      title: '目标看板',
    },
  },
  {
    path: '/targetManage/dataBoard/dataDetail',
    name: 'dataDetailIndex',
    component: () => import('../views/targetManage/dataBoard/dataDetail'),
    meta: {
      title: '数据详情',
    },
  },
  {
    path: '/targetManage/dataBoard/dataDetailStore',
    name: 'dataDetailStoreIndex',
    component: () => import('../views/targetManage/dataBoard/dataDetailStore'),
    meta: {
      title: '数据详情',
    },
  },
]
const rankRouter = [
  {
    path: '/rank/index',
    name: 'rankIndex',
    component: () => import('../views/rank/index.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/rank/zone',
    name: 'rankZone',
    component: () => import('../views/rank/zone.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/rank/branch',
    name: 'rankBranch',
    component: () => import('../views/rank/branch.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/rank/store',
    name: 'rankStore',
    component: () => import('../views/rank/store.vue'),
    meta: {
      title: '',
    },
  },
]

const integralRouter = [
  {
    path: '/integral/myself/index',
    name: 'myselfIndex',
    component: () => import('../views/integral/myself/index.vue'),
    meta: {
      title: '我的积分',
    },
  },
  {
    path: '/integral/staff/index',
    name: 'staffIndex',
    component: () => import('../views/integral/staff/index.vue'),
    meta: {
      title: '员工排行',
    },
  },
  {
    path: '/integral/staff/zone',
    name: 'staffZone',
    component: () => import('../views/integral/staff/zone.vue'),
    meta: {
      title: '员工排行',
    },
  },
  {
    path: '/integral/staff/branch',
    name: 'staffBranch',
    component: () => import('../views/integral/staff/branch.vue'),
    meta: {
      title: '员工排行',
    },
  },
  {
    path: '/integral/staff/store',
    name: 'staffStore',
    component: () => import('../views/integral/staff/store.vue'),
    meta: {
      title: '员工排行',
    },
  },
  {
    path: '/integral/staff/staff',
    name: 'staffStaff',
    component: () => import('../views/integral/staff/staff.vue'),
    meta: {
      title: '员工排行',
    },
  },
]

// 排班路由
const schedulingRouter = [
  {
    path: '/scheduling/index',
    name: 'schedulingIndex',
    component: () => import('../views/scheduling/index.vue'),
    meta: {
      title: '员工排班',
    },
  },
  {
    path: '/scheduling/administrator/index',
    name: 'administratorIndex',
    component: () => import('../views/scheduling/administrator/index.vue'),
    meta: {
      title: '管理组排班结果',
    },
  },
  {
    path: '/scheduling/support/index',
    name: 'supportIndex',
    component: () => import('../views/scheduling/support/index.vue'),
    meta: {
      title: '支援管理',
    },
  },
  {
    path: '/scheduling/support/support',
    name: 'supportEr',
    component: () => import('../views/scheduling/support/support.vue'),
    meta: {
      title: '派出支援',
    },
  },
  {
    path: '/scheduling/asForLeave/index',
    name: 'asForLeave',
    component: () => import('../views/scheduling/asForLeave/index.vue'),
    meta: {
      title: '请假',
    },
  },
  {
    path: '/scheduling/asForLeave/applyFor',
    name: 'applyFor',
    component: () => import('../views/scheduling/asForLeave/applyFor.vue'),
    meta: {
      title: '请假申请',
      children: [],
    },
  },
  {
    path: '/scheduling/asForLeave/applyForList',
    name: 'applyForList',
    component: () => import('../views/scheduling/asForLeave/applyForList.vue'),
    meta: {
      title: '审批列表',
    },
  },
  {
    path: '/scheduling/asForLeave/eliminate',
    name: 'eliminate',
    component: () => import('../views/scheduling/asForLeave/eliminate.vue'),
    meta: {
      title: '销假',
    },
  },
  {
    path: '/scheduling/setWork/index',
    name: 'setWorkIndex',
    component: () => import('../views/scheduling/setWork/index.vue'),
    meta: {
      title: '给班',
    },
  },
  {
    path: '/scheduling/setWork/timeCalendar',
    name: 'setTimeCalendar',
    component: () => import('../views/scheduling/setWork/timeCalendar.vue'),
    meta: {
      title: '按小时给班',
    },
  },
]
//出品方案
const productionPlanRouter = [
  {
    path: '/productionPlan/index',
    name: 'productionPlanIndex',
    component: () => import('../views/productionPlan/index'),
    meta: {
      title: '菜品看板/打印机设置',
    },
  },
  {
    path: '/productionPlan/setUp/productionMethod',
    name: 'productionMethod',
    component: () => import('../views/productionPlan/setUp/productionMethod'),
    meta: {
      title: '选择出品方式',
    },
  },
  {
    path: '/productionPlan/setUp/dishInformation',
    name: 'dishInformation',
    component: () => import('../views/productionPlan/setUp/dishInformation'),
    meta: {
      title: '选择菜品信息',
    },
  },
  {
    path: '/productionPlan/operaRecord/index',
    name: 'operaRecordIndex',
    component: () => import('../views/productionPlan/operaRecord/index'),
    meta: {
      title: '操作记录',
    },
  },
  {
    path: '/productionPlan/operaRecord/testInfo',
    name: 'testInfoIndex',
    component: () => import('../views/productionPlan/operaRecord/testInfo'),
    meta: {
      title: '操作记录',
    },
  },
  {
    path: '/productionPlan/setUp/verifyInformation',
    name: 'verifyInformation',
    component: () => import('../views/productionPlan/setUp/verifyInformation'),
    meta: {
      title: '核对信息',
    },
  },
  {
    path: '/productionPlan/setUp/checkTestInfo',
    name: 'checkTestInfo',
    component: () => import('../views/productionPlan/setUp/checkTestInfo'),
    meta: {
      title: '验证测试信息',
    },
  },
  {
    path: '/productionPlan/setUp/chooseKitchen',
    name: 'chooseKitchen',
    component: () => import('../views/productionPlan/setUp/chooseKitchen'),
    meta: {
      title: '选择厨房',
    },
  },
  {
    path: '/productionPlan/setUp/diningOutSignage',
    name: 'diningOutSignage',
    component: () => import('../views/productionPlan/setUp/diningOutSignage'),
    meta: {
      title: '设置出餐看板',
    },
  },
  {
    path: '/productionPlan/viewDishes/dishMessage',
    name: 'dishMessage',
    component: () => import('../views/productionPlan/viewDishes/dishMessage'),
    meta: {
      title: '菜品信息',
    },
  },
  {
    path: '/productionPlan/viewDishes/boardMessage',
    name: 'boardMessage',
    component: () => import('../views/productionPlan/viewDishes/boardMessage'),
    meta: {
      title: '查看看板/打印机',
    },
  },
  {
    path: '/productionPlan/viewDishes/madeKitchen',
    name: 'madeKitchen',
    component: () => import('../views/productionPlan/viewDishes/madeKitchen'),
    meta: {
      title: '制作厨房',
    },
  },
  {
    path: '/productionPlan/testDishes/dishMessage',
    name: 'testDishMessage',
    component: () => import('../views/productionPlan/testDishes/dishMessage'),
    meta: {
      title: '菜品信息',
    },
  },
  {
    path: '/productionPlan/testDishes/testInfo',
    name: 'dishTestInfo',
    component: () => import('../views/productionPlan/testDishes/testInfo'),
    meta: {
      title: '验证测试信息',
    },
  },
]

const routes = publicRoutes.concat(waimaiRouter).concat(kvsRouter).concat(kdsRouter).concat(rankRouter).concat(integralRouter).concat(targetRouter).concat(schedulingRouter).concat(productionPlanRouter).concat(estimateRouter)

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    if (jw && jw.setTitle) {
      jw.setTitle({ title: to.meta.title })
    }
  }
  next() // 确保一定要调用 next()
})

export default router
